import { BeehiivUser } from '../../types/beehiiv-types'
import { fetchNetlify } from '../netlify'

export const getUserFromEmail = async (email: string) =>
  await fetchNetlify<BeehiivUser>(`/.netlify/functions/beehiiv-account-lookup?email=${email}`)

export const createBeehiivUser = async (email: string, stripe_customer_id: string) =>
  await fetchNetlify<BeehiivUser>(
    `/.netlify/functions/beehiiv-account-create?email=${email}&stripe_customer_id=${stripe_customer_id}`
  )

export const updateSubscriberMetadata = async (
  subscription_id?: string | null,
  {
    profile_url,
    verbs,
    nouns,
    skills,
    cobenefits,
    subscribe
  }: {
    profile_url?: string
    verbs?: string
    nouns?: string
    skills?: string
    cobenefits?: string
    subscribe?: boolean
  } = {}
) => {
  if (!subscription_id || subscription_id === 'null' || subscription_id === 'undefined') {
    if (typeof window !== 'undefined') {
      console.warn('[beehiiv] updateSubscriberMetadata skipped: no subscription id')
    }
    return
  }

  const params = new URLSearchParams({ subscription_id })

  if (profile_url) {
    params.set('profile_url', profile_url)
  }
  if (verbs !== undefined) {
    params.set('verbs', verbs == '' ? 'none' : verbs)
  }
  if (nouns !== undefined) {
    params.set('nouns', nouns == '' ? 'none' : nouns)
  }
  if (skills !== undefined) {
    params.set('skills', skills == '' ? 'none' : skills)
  }
  if (cobenefits !== undefined) {
    params.set('cobenefits', cobenefits == '' ? 'none' : cobenefits)
  }
  if (subscribe !== undefined) {
    params.set('subscribe', subscribe ? 'true' : 'false')
  }

  await fetchNetlify(`/.netlify/functions/beehiiv-update_subscriber_metadata?${params.toString()}`)
}
